<template>
 <div>
       <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
      <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab"> Detalle Prestamo</b-card-header>
      <b-card-body>
      <div> 
                         <div class="row" style="padding: 5px;  #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                                <div class="col-12">
                                                <div class="row">
                                                    <span><b>Producto :</b> {{model.DescripcionProductoCredito}}</span>
                                                    </div>
                                                    <div class="row">
                                                        <span><b>Monto</b>: {{model.Monto}}</span>
                                                    </div>
                                                    <div class="row">
                                                        <span><b>Fecha de Acreditacion:</b> {{model.FechaAcreditacion}}</span>
                                                    </div>
                                                    <div class="row">
                                                        <span><b>Valor Cuota :</b> {{model.ValorCuota}}</span>
                                                    </div>
                                                    <div class="row">
                                                        <span><b>TNA:</b> {{model.TNA}}</span>
                                                    </div>
                                                    <div class="row">
                                                        <span><b>CFT:</b> {{model.CFT}}</span>
                                                    </div>
                                    </div>
                         </div>
      </div>
   </b-card-body>
    </b-card> 
          <b-card style="margin: 20px">
      <b-card-body>
 
      <div> 
                    <div class="row" style="padding: 5px;  #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                        <div class="col-10">
                             <div class="row">
                                <div class="col-1" >
                                   <img :src="getImgUrl(model.ImagenEstado)" :alt="model.ImagenEstado" width="60px">
                                </div>
                                <div class="col-6">
                                    <div class="row h4" style="color:green;">
                                        <span>{{model.NombreEstado}}</span>
                                    </div>
                                    <div class="row">
                                        <span>{{model.FechaProximaCuotaFormateada}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 text-right mt-4"></div>
                    </div>
      </div>
   </b-card-body>
    </b-card>
 <div class="col-md-12">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-success" @click="goBack"
                  >Volver</b-button
                >
              </div>
            </div>
  </div>
  </div>
</template>
<style>


</style>

<script>
export default {
     name: "miprestamoPersonal",
      props: {
        imagenEstado: String,
        descripcionProductoCredito: String,
        nombreEstado: String,
        fechaProximaCuotaFormateada: String,
        monto: String,
        fechaAcreditacion: String,
        valorCuota:String,
        tna:String,
        cft:String
      },
      data(){
            return{
                model: {   
                   ImagenEstado:this.imagenEstado,
                   DescripcionProductoCredito:this.descripcionProductoCredito,
                   NombreEstado:this.nombreEstado,
                   FechaAcreditacion:this.fechaAcreditacion,
                   FechaProximaCuotaFormateada:this.fechaProximaCuotaFormateada,
                   Monto:this.monto,
                   ValorCuota:this.valorCuota,
                   TNA:this.tna,
                   CFT:this.cft
                },
                
            }
        },
        beforeMount() {
            let context=this;
        },
        methods:{
            getImgUrl(pic) {
                    return "/img/"+pic
            },
            goBack(){
                  let context = this;
                  context.$router.push("misprestamos");
            }

        }
       
}
</script>